import React, { FC } from 'react'
import styles from 'styles/components/label.module.scss'
import { Spacer } from 'components/Utility'
import { RequiredLabel } from 'components/Label'
import classNames from 'classnames'

type Props = {
  id?: string
  label: string
  required: boolean
  size?: 'small' | 'medium'
  width?: 'auto' | undefined
}

const FormLabel: FC<Props> = React.memo((props) => {
  const { id, label, required, size = 'medium', width } = props
  return (
    <label
      className={classNames({
        [styles.form]: width === undefined,
        [styles.form_width_auto]: width === 'auto',
      })}
      id={id}
    >
      <span
        className={classNames({
          [styles.form__text]: size === 'medium',
          [styles.form__text_small]: size === 'small',
        })}
      >
        {label}
      </span>
      <Spacer size={4} axis={'horizontal'} />
      {required && <RequiredLabel />}
    </label>
  )
})

export default FormLabel
